import { render, staticRenderFns } from "./StackedArea.vue?vue&type=template&id=c9ce3ef4"
import script from "./StackedArea.vue?vue&type=script&lang=js"
export * from "./StackedArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports